import axios from "axios"

const api = axios.create({
   baseURL: `${process.env.REACT_APP_API_ENDPOINT}`,
   headers: {
      Accept: "application/json",
      // "Accept-Charset": "utf-8",
      "Content-Type": "application/json",
   },
})

const LATIN_MOJIBAKE_PATTERN = /[ÐÑÃÂ][\u0080-\u00FF]/
const CP1251_MOJIBAKE_PATTERN = /[РС][\u00A0-\u00FF]/
const MOJIBAKE_MARKERS = /[ÐÑÃÂ][\u0080-\u00FF]|[РС][\u00A0-\u00FF]/g

const shouldTryUtf8Repair = (value) => {
   if (typeof value !== "string" || value.length < 2) {
      return false
   }

   return LATIN_MOJIBAKE_PATTERN.test(value) || CP1251_MOJIBAKE_PATTERN.test(value)
}

const decodeLatin1BytesAsUtf8 = (value) => {
   try {
      const bytes = new Uint8Array(value.length)
      for (let i = 0; i < value.length; i++) {
         bytes[i] = value.charCodeAt(i) & 0xff
      }
      return new TextDecoder("utf-8", { fatal: false }).decode(bytes)
   } catch (error) {
      return value
   }
}

const decodeUtf8BytesAsWindows1251 = (value) => {
   try {
      const bytes = new TextEncoder().encode(value)
      return new TextDecoder("windows-1251", { fatal: false }).decode(bytes)
   } catch (error) {
      return value
   }
}

const getMojibakeScore = (value) => {
   if (typeof value !== "string") {
      return 0
   }

   const markers = value.match(MOJIBAKE_MARKERS)
   return markers ? markers.length : 0
}

const repairMojibake = (value) => {
   const candidates = [
      value,
      decodeLatin1BytesAsUtf8(value),
      decodeUtf8BytesAsWindows1251(value),
   ]

   let best = value
   let bestScore = getMojibakeScore(value)

   for (let i = 1; i < candidates.length; i++) {
      const candidate = candidates[i]
      const candidateScore = getMojibakeScore(candidate)
      if (candidateScore < bestScore) {
         best = candidate
         bestScore = candidateScore
      }
   }

   return best
}

const normalizeResponseText = (input) => {
   if (typeof input === "string") {
      return shouldTryUtf8Repair(input) ? repairMojibake(input) : input
   }

   if (Array.isArray(input)) {
      return input.map((item) => normalizeResponseText(item))
   }

   if (input && typeof input === "object") {
      const output = {}
      Object.keys(input).forEach((key) => {
         output[key] = normalizeResponseText(input[key])
      })
      return output
   }

   return input
}

api.interceptors.response.use((response) => {
   const responseType = response?.config?.responseType
   const shouldSkipNormalization =
      responseType && responseType !== "json" && responseType !== "text"

   if (!shouldSkipNormalization && response?.data) {
      response.data = normalizeResponseText(response.data)
   }

   return response
})

export default api
